export const getSubdomain = (url: string): string => {
  try {
    const { hostname } = new URL(url)

    const parts = hostname.split('.')

    if (parts.length > 2) {
      return parts[0]
    } else {
      return 'dev'
    }
  } catch {
    return 'dev'
  }
}
